'use client';

import React from 'react';
import { Search, FileText, Download, Plus } from 'lucide-react';

interface ClientsFilterBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onOpenSelectedProfile: () => void;
  onOpenImport: () => void;
  onOpenNewClient: () => void;
  hasSelectedClient: boolean;
}

export default function ClientsFilterBar({
  searchTerm,
  onSearchChange,
  onOpenSelectedProfile,
  onOpenImport,
  onOpenNewClient,
  hasSelectedClient
}: ClientsFilterBarProps) {
  return (
    <div className="flex flex-col md:flex-row items-stretch md:items-center justify-between gap-3">
      {/* Buscador */}
      <div className="relative flex-1 max-w-md">
        <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-slate-400">
          <Search className="w-4 h-4" />
        </div>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Buscar por nombre, teléfono o email"
          className="w-full pl-10 pr-4 py-2 bg-white border border-slate-200/90 rounded-2xl text-xs md:text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 shadow-sm transition"
        />
      </div>

      {/* Botones de Acción */}
      <div className="flex items-center gap-2.5 self-end md:self-center">
        <button
          onClick={onOpenSelectedProfile}
          disabled={!hasSelectedClient}
          className="flex items-center gap-1.5 px-3.5 py-2 bg-white border border-slate-200/90 hover:border-slate-300 text-slate-700 disabled:opacity-40 text-xs font-semibold rounded-2xl shadow-sm transition"
          title="Ver ficha 360° del cliente seleccionado"
        >
          <FileText className="w-3.5 h-3.5 text-slate-500" />
          <span>Ficha del cliente</span>
        </button>

        <button
          onClick={onOpenImport}
          className="flex items-center gap-1.5 px-3.5 py-2 bg-white border border-slate-200/90 hover:border-slate-300 text-slate-700 text-xs font-semibold rounded-2xl shadow-sm transition"
          title="Importar contactos desde agenda o Excel"
        >
          <Download className="w-3.5 h-3.5 text-slate-500" />
          <span>Importar</span>
        </button>

        <button
          onClick={onOpenNewClient}
          className="flex items-center gap-1.5 px-4 py-2 bg-[#047857] hover:bg-[#065f46] text-white text-xs font-bold rounded-2xl shadow-sm transition transform active:scale-95"
        >
          <Plus className="w-4 h-4 stroke-[2.5]" />
          <span>Nuevo Cliente</span>
        </button>
      </div>
    </div>
  );
}
